import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./RecurringPlans.css";
import axios from "axios";

function RecurringPlans() {
  const [subscriptions, setSubscriptions] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  sessionStorage.removeItem("parentPage");

  const useremail_id = sessionStorage.getItem("userEmail");

  const navigate = useNavigate();

  const navigateTO = (email_id, subscription_id, crm_sub_id) => {
    navigate(`/plansdetail`, {
      state: { email_id, subscription_id, crm_sub_id },
    });
  };

  const convertDate = (dateString) => {
    const date = new Date(dateString);

    const day = date.getDate();
    const month = date.toLocaleString("default", { month: "long" });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
  };
  const custom_id = "cus_Re4RE4YYST8xzc";
  const email_id = "danielzh@fullsuite.agency";

  useEffect(() => {
    axios
      .get(`/server/subscription/customer/activeSubscription/${useremail_id}`)
      .then((response) => {
        const subscriptions = response.data.data;

        const subscriptionsData = subscriptions
          .map((subscription) => {
            const sub_name = subscription.Subscription_Name;
            const sub_amount = subscription.Subscription_Amount;
            const sub_frequency = subscription.Frequency;
            const active = subscription.Active ? "Active" : "Inactive";
            const nextDonation = convertDate(subscription.Next_Payment_Date);
            const sub_id = subscription.Stripe_Subscription_Id;
            const crm_sub_id = subscription.CRM_Subscription_Id;

            return {
              name: sub_name,
              amount: sub_amount != null ? `$${sub_amount.toFixed()}` : "",
              active_status: active,
              frequency: sub_frequency,
              nextDonationDate: nextDonation,
              subscription_id: sub_id,
              crm_sub_id: crm_sub_id,
              // status: status.charAt(0).toUpperCase() + status.slice(1),
            };
          })
          .filter(Boolean);

        setSubscriptions(subscriptionsData);
      })
      .catch((error) => console.error("Error fetching subscription data:", error))
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <div className="bg-[#F7F7F7] -m-[23px] p-[30px] min-h-screen pl-[45px] pr-[45px] flex flex-col ">
      {/* Heading */}
      {isLoading && (
        <div className="absolute inset-0 fixed flex h-90vh justify-center items-center bg-white bg-opacity-75 z-50">
          <div className="animate-spin w-12 h-12 border-[4px] rounded-full border-l-[#095856] border-black"></div>
        </div>
      )}
      <div className="flex flex-col mb-4">
        <h5 className="font-Jost text-2xl font-medium leading-[36.4px] mb-2">Recurring Plans</h5>
        <p className="font-Jost text-lg font-normal leading-[38.6px] text-[#1A1B1C]">List of recurring plans.</p>
      </div>
      {/* Donation Cards */}
      <div className="flex-1 overflow-y-auto max-h-[calc(100vh-150px)] scrollbar">
        <div className="flex flex-col gap-[18px]  max-sm:gap-[20px]">
          {subscriptions.length > 0 ? (
            subscriptions.map((donation) => (
              <div
                key={donation.subscription_id}
                className="flex flex-row justify-center cursor-pointer items-center max-sm:flex-col max-sm:justify-start max-sm:items-start max-sm:block"
                onClick={() => navigateTO(email_id, donation.subscription_id, donation.crm_sub_id)}
              >
                <div className="bg-white rounded-[8px] border-[1px] border-[#0000001A] h-[121px] w-[100%] p-[40px] pr-[32px] pl-[25px]  shadow-none max-sm:w-[auto] max-sm:h-[auto] max-sm:p-[20px]">
                  <div className="flex flex-row gap-[50px] items-center max-sm:flex-col max-sm:gap-[20px]">
                    {/*Title*/}
                    <div className="flex items-center w-[250px] h-[49px] max-sm:w-[100%]  max-sm:items-start max-sm:h-[auto]">
                      <p
                        className="font-Jost text-lg font-medium text-[#0E5C57] cursor-pointer line-clamp-1-5"
                        onClick={() => navigateTO(email_id, donation.subscription_id, donation.crm_sub_id)}
                      >
                        {donation.name}
                      </p>
                    </div>

                    <div className="flex flex-col items-center w-[250px] h-[48px] text-center max-sm:w-[100%] max-sm:items-start">
                      <p className="text-black font-Jost text-[18px] font-normal">{donation.amount}</p>
                      <p className="text-[18px] text-black-400 font-Jost text-sm">
                        {/* {donation.frequency} */}
                        {donation.frequency}
                      </p>
                    </div>

                    {/* Date Container */}
                    <div className="flex flex-col items-left w-[300px] max-sm:w-[100%] max-sm:items-start">
                      <p className="text-[#0E5C57] font-Jost text-[18px] font-normal items-center">{donation.active_status}</p>
                      {donation.active_status === "Active" && (
                        <p className="text-black font-Jost text-[18px] font-normal">Next Donation: {donation.nextDonationDate}</p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p className="text-center text-gray-500 mt-60">No subscriptions found.</p>
          )}
        </div>
      </div>
    </div>
  );
}

export default RecurringPlans;
